var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    id: "a_slide_show",
    d: "M0 0h12.75v6.8H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M1.275.85a.426.426 0 0 0-.425.425v11.9c0 .235.191.425.425.425h17.85c.234 0 .425-.19.425-.425v-11.9a.426.426 0 0 0-.425-.425H1.275zm17.85 13.6H1.275A1.277 1.277 0 0 1 0 13.175v-11.9C0 .572.572 0 1.275 0h17.85c.703 0 1.275.572 1.275 1.275v11.9c0 .703-.572 1.275-1.275 1.275z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.775 20.4a.425.425 0 0 1-.425-.425v-5.95a.425.425 0 0 1 .85 0v5.95c0 .235-.19.425-.425.425"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.4 13.6)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b_slide_show",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a_slide_show"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.325 6.8a.427.427 0 0 1-.3-.124l-5.65-5.65-5.65 5.65a.426.426 0 0 1-.6-.602l5.95-5.95a.426.426 0 0 1 .6 0l5.95 5.95a.426.426 0 0 1-.3.726",
    mask: "url(#b_slide_show)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19.975 4.25H.425a.425.425 0 0 1 0-.85h19.55a.425.425 0 0 1 0 .85"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.6f1074954fb247908200353107c4e711.svg";
export { ForwardRef as ReactComponent };